import { Injectable } from '@angular/core';

import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PricesService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  addPrice(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/add-price`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPrices(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/get-prices`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPriceByExperienceId(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/get-price-by-experience`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPriceById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/get-price-by-id`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPriceByDocId(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/get-price-by-doctor`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  editPrice(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/edit-price`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  deletePriceById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/delete-price`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  addPromoCode(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/add-promocode`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPromoCodeList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/get-promocodes`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getGiftCode(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/getGiftCode`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }
  getNewGiftCode(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/getNewGiftCode`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  deletePromoCode(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/delete-promocode`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  processPaymentRefund(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments/processpaymentrefund`,data)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }


  addGst(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/add-gst`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getGstList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/get-gst`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  addApiKey(Payload) {
    return this.http.post<any>(`${this.baseUrl}/insurance/addApiKey`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getApiKeyList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/insurance/getApiKeyList`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getApiKeyById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/insurance/getApiKeyById`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }
  editApiKey(Payload) {
    return this.http.post<any>(`${this.baseUrl}/insurance/editApiKey`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }
  deleteApiKey(Payload) {
    return this.http.post<any>(`${this.baseUrl}/insurance/deleteApiKey`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }


  addCouponCode(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/add-couponcode`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getCodeCodeList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/get-couponcodes`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  deleteCouponCode(Payload) {
    return this.http.post<any>(`${this.baseUrl}/prices/delete-couponcode`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  addPlan(Payload) {
    return this.http.post<any>(`${this.baseUrl}/plan/addplan`, Payload)
      .pipe(map(res => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPlanList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/plan/getplanslist`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  getPlanById(id): Observable<any> {
    return this.http.get(`${this.baseUrl}/plan/getplansbyid/${id}`)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }
  updatePlan(id, payload): Observable<any> {
    return this.http.put(`${this.baseUrl}/plan/updateplan/${id}`, payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }

  deleteandundeletePlan(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/plan/deleteplan`,payload)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError(PricesService.handleError));
  }


}
